import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { currency } from '../../../dynamicController';
import { useTranslation } from "react-i18next";

const colorSets = [
    {
        headColor: "#c596c4",
        bodyColor: "linear-gradient(135deg , #c8bfde , #a1c3e9)"
    },
    {
        headColor: "#fbcc7d",
        bodyColor: "linear-gradient(135deg , #f6b997 , #f38695)"
    },
    {
        headColor: "#93c9ed",
        bodyColor: "linear-gradient(135deg , #6599d3 , #77cebb)"
    },
    {
        headColor: "#c7a1aa",
        bodyColor: "linear-gradient(135deg , #f2d0e0 , #c6a9d2)"
    },
    {
        headColor: "#b6da98",
        bodyColor: "linear-gradient(135deg , #cee6a9 , #dbde91)"
    }
];

const randomNumber = Math.floor(Math.random() * colorSets.length);
const selectedColor = colorSets[randomNumber];


const SettingForm = ({ selected, washerSetting, dryerSetting, combinedSetting, handleCheckbox, handleChange, handleSubmit, combined, payAndGetRegVoucher, regVoucherAmount, reg_voucher_method, handlePayAndGetRegVoucher, handleRegVoucherAmount, handleRegVoucherMethod, payAndGetBirthdayVoucher, birthdayVoucherAmount, handlePayAndGetBirthdayVoucher, handleBirthdayVoucherAmount, country }) => {

    const { t } = useTranslation();

    if (selected === "Stamp") {
        // stamp, got combined view and separated view
        if (combined) {
            // stamp combined setting
            return (
                <div>
                    <div>
                        {/* stamp voucher preview */}
                        <div className="voucher mb-5">
                            <div className="voucher-ball left-ball"></div>
                            <div className="voucher-head p-0 m-0" style={{ backgroundColor: selectedColor.headColor }}>
                                <h4 style={{ width: "140px", height: "140px", padding: "18px 0 0 0" }}>{t("DISCOUNT")}</h4>
                            </div>

                            <div className="voucher-content" style={{ background: selectedColor.bodyColor }}>
                                <div>
                                    <h1>{combinedSetting.voucher_type === "Flat" ? (`${currency(country)}${combinedSetting.voucher_amount}`) : (`${combinedSetting.voucher_amount}%`)}</h1>
                                </div>

                                <div>
                                    <h5>{combinedSetting.voucher_title}</h5>
                                    <h6>{combinedSetting.voucher_description}</h6>
                                </div>
                            </div>
                            <div className="voucher-ball right-ball"></div>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit} id="setting-form">
                        <div className="text-start">
                            {/* checkboxes */}
                            <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                <div className="form-group">
                                    <label htmlFor="voucher_eligible">
                                        <input type="checkbox" id="voucher_eligible" name="voucher_eligible" checked={combinedSetting.voucher_eligible} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the system will give voucher to user who completed stamp collection")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Eligibility")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="voucher_expiry">
                                        <input type="checkbox" id="voucher_expiry" name="voucher_expiry" checked={combinedSetting.voucher_expiry} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the voucher will have expired date")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Expiry")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>
                            </div>

                            <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="voucher_washer_use" name="voucher_washer_use" checked={combinedSetting.voucher_washer_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the voucher can apply to washer machine transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Washer Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="voucher_dryer_use" name="voucher_dryer_use" checked={combinedSetting.voucher_dryer_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the voucher can apply to dryer machine transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Dryer Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="voucher_package_use" name="voucher_package_use" checked={combinedSetting.voucher_package_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the voucher can apply to Drop n Go transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Package Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>
                            </div>

                            <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="voucher_vending_use" name="voucher_vending_use" checked={combinedSetting.voucher_vending_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the voucher can apply to vending machine transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Vending Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="voucher_detergent_use" name="voucher_detergent_use" checked={combinedSetting.voucher_detergent_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the voucher can apply to detergent vending machine transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Detergent Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>
                                        <input type="checkbox" id="voucher_carwash_use" name="voucher_carwash_use" checked={combinedSetting.voucher_carwash_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    {t("If ticked, the voucher can apply to car wash transaction")}
                                                </Tooltip>
                                            }
                                        >
                                            <span>{t("Car Wash Use")}</span>
                                        </OverlayTrigger>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div>
                            {/* text and select */}
                            {
                                combinedSetting.voucher_expiry
                                    ? (
                                        <div className="form-group">
                                            <label htmlFor="voucher_duration">{t("Voucher Lifespan")} : <small> ({t("days")})</small></label>
                                            <input type="number" id="voucher_duration" name="voucher_duration" value={combinedSetting.voucher_duration} onChange={e => handleChange("combinedSetting", e.target)} required min="0" />
                                        </div>
                                    )
                                    : (
                                        null
                                    )
                            }

                            <div className="form-group">
                                <label htmlFor="voucher_type">{t("Discount Type")} : </label>
                                <select className="browser-default form-select" id="voucher_type" name="voucher_type" value={combinedSetting.voucher_type} onChange={e => handleChange("combinedSetting", e.target)} required>
                                    <option value="" disabled>{t("Select a discount type")}</option>
                                    <option value="Flat">{t("Flat")} (- {currency(country)})</option>
                                    <option value="Rate">{t("Rate")} (- %)</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="voucher_title">{t("Voucher Title")} : </label>
                                <input type="text" id="voucher_title" name="voucher_title" placeholder={t("Voucher Title")} value={combinedSetting.voucher_title} onChange={e => handleChange("combinedSetting", e.target)} required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="voucher_description">{t("Voucher Description")} : </label>
                                <input type="text" id="voucher_description" name="voucher_description" placeholder={t("Voucher Description")} value={combinedSetting.voucher_description} onChange={e => handleChange("combinedSetting", e.target)} required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="voucher_amount">{t("Voucher Amount")} : <small>{combinedSetting.voucher_type === "Flat" ? `(${currency(country)})` : "(%)"}</small></label>
                                <input type="number" id="voucher_amount" name="voucher_amount" value={combinedSetting.voucher_amount} onChange={e => handleChange("combinedSetting", e.target)} required min="0" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="recurring_number">{t("Total number of voucher given to user")}:</label>
                                <input
                                    type="number"
                                    id="recurring_number"
                                    name="recurring_number"
                                    value={combinedSetting.recurring_number}
                                    onChange={e => handleChange("combinedSetting", e.target)}
                                    min="1"
                                    max="100"
                                    step="1"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="recurrence_type">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>{t("Select the voucher recurrence behavior")}</Tooltip>}
                                    >
                                        <span>{t("Recurrence Type")}</span>
                                    </OverlayTrigger>
                                </label>
                                <select
                                    className="browser-default form-select"
                                    id="recurrence_type"
                                    name="recurrence_type"
                                    value={combinedSetting.recurrence_type}
                                    onChange={e => handleChange("combinedSetting", e.target)}
                                >
                                    <option value="" disabled>{t("Select Recurrence Type")}</option>
                                    <option value="Recurring">{t("Recurring")}</option>
                                    <option value="Multiple">{t("Multiple Voucher")}</option>
                                </select>
                            </div>

                            {
                                combinedSetting.recurrence_type === "Recurring" && (
                                    <div className="form-group">
                                        <label htmlFor="recurring_period">{t("Period for giving next voucher (days)")}:</label>
                                        <input
                                            type="number"
                                            id="recurring_period"
                                            name="recurring_period"
                                            value={combinedSetting.recurring_period}
                                            onChange={e => handleChange("combinedSetting", e.target)}
                                            min="1"
                                            step="1"
                                            required
                                        />
                                    </div>
                                )
                            }
                        </div>

                        <div className="my-4">
                            <input type="submit" value={t("CONFIRM")} className="btn big-button form-control" />
                        </div>
                    </form>
                </div>
            )
        } else {
            // separated stamp setting
            return (
                <div>
                    <form onSubmit={handleSubmit}>
                        <div className="d-flex justify-content-around">
                            {/* washer */}
                            <div>
                                {/* washer voucher preview */}
                                <h3>{t("Washer")}</h3>
                                <div className="voucher mb-5">
                                    <div className="voucher-ball left-ball"></div>
                                    <div className="voucher-head p-0 m-0" style={{ backgroundColor: selectedColor.headColor }}>
                                        <h4 style={{ width: "140px", height: "140px", padding: "18px 0 0 0" }}>{t("DISCOUNT")}</h4>
                                    </div>

                                    <div className="voucher-content" style={{ background: selectedColor.bodyColor }}>
                                        <div>
                                            <h1>{washerSetting.voucher_type === "Flat" ? (`${currency(country)}${washerSetting.voucher_amount}`) : (`${washerSetting.voucher_amount}%`)}</h1>
                                        </div>

                                        <div>
                                            <h5>{washerSetting.voucher_title}</h5>
                                            <h6>{washerSetting.voucher_description}</h6>
                                        </div>
                                    </div>
                                    <div className="voucher-ball right-ball"></div>
                                </div>
                                {/* washer form */}
                                <div>
                                    <div>
                                        <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_eligible" name="voucher_eligible" checked={washerSetting.voucher_eligible} onChange={e => handleCheckbox("washerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the system will give voucher to user who completed washer stamp collection")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Eligibility")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_expiry" name="voucher_expiry" checked={washerSetting.voucher_expiry} onChange={e => handleCheckbox("washerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher will have expired date")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Expiry")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>

                                        <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_washer_use" name="voucher_washer_use" checked={washerSetting.voucher_washer_use} onChange={e => handleCheckbox("washerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to washer machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Washer Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_dryer_use" name="voucher_dryer_use" checked={washerSetting.voucher_dryer_use} onChange={e => handleCheckbox("washerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to dryer machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Dryer Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_package_use" name="voucher_package_use" checked={washerSetting.voucher_package_use} onChange={e => handleCheckbox("washerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to Drop n Go transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Package Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>

                                        <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_vending_use" name="voucher_vending_use" checked={washerSetting.voucher_vending_use} onChange={e => handleCheckbox("washerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to vending machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Vending Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_detergent_use" name="voucher_detergent_use" checked={washerSetting.voucher_detergent_use} onChange={e => handleCheckbox("washerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to detergent vending machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Detergent Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_carwash_use" name="voucher_carwash_use" checked={washerSetting.voucher_carwash_use} onChange={e => handleCheckbox("washerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to car wash transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Car Wash Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        {
                                            washerSetting.voucher_expiry
                                                ? (
                                                    <div className="form-group">
                                                        <label htmlFor="voucher_duration">{t("Voucher Lifespan")} : <small> ({t("days")})</small></label>
                                                        <input type="number" id="voucher_duration" name="voucher_duration" value={washerSetting.voucher_duration} onChange={e => handleChange("washerSetting", e.target)} required min="0" />
                                                    </div>
                                                )
                                                : (
                                                    null
                                                )
                                        }

                                        <div className="form-group">
                                            <label htmlFor="voucher_type">{t("Discount Type")} : </label>
                                            <select className="browser-default form-select" id="voucher_type" name="voucher_type" value={washerSetting.voucher_type} onChange={e => handleChange("washerSetting", e.target)} required>
                                                <option value="" disabled>{t("Select a discount type")}</option>
                                                <option value="Flat">{t("Flat")} (- {currency(country)})</option>
                                                <option value="Rate">{t("Rate")} (- %)</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_title">{t("Voucher Title")} : </label>
                                            <input type="text" id="voucher_title" name="voucher_title" placeholder={t("Voucher Title")} value={washerSetting.voucher_title} onChange={e => handleChange("washerSetting", e.target)} required />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_description">{t("Voucher Description")} : </label>
                                            <input type="text" id="voucher_description" name="voucher_description" placeholder={t("Voucher Description")} value={washerSetting.voucher_description} onChange={e => handleChange("washerSetting", e.target)} required />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_amount">{t("Voucher Amount")} : <small>{washerSetting.voucher_type === "Flat" ? `(${currency(country)})` : "(%)"}</small></label>
                                            <input type="number" id="voucher_amount" name="voucher_amount" value={washerSetting.voucher_amount} onChange={e => handleChange("washerSetting", e.target)} required min="0" />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="recurring_number">{t("Total number of voucher given to user")}:</label>
                                            <input
                                                type="number"
                                                id="recurring_number"
                                                name="recurring_number"
                                                value={washerSetting.recurring_number}
                                                onChange={e => handleChange("washerSetting", e.target)}
                                                min="1"
                                                max="100"
                                                step="1"
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="recurrence_type">
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>{t("Select the voucher recurrence behavior")}</Tooltip>}
                                                >
                                                    <span>{t("Recurrence Type")}</span>
                                                </OverlayTrigger>
                                            </label>
                                            <select
                                                className="browser-default form-select"
                                                id="recurrence_type"
                                                name="recurrence_type"
                                                value={washerSetting.recurrence_type}
                                                onChange={e => handleChange("washerSetting", e.target)}
                                            >
                                                <option value="" disabled>{t("Select Recurrence Type")}</option>
                                                <option value="Recurring">{t("Recurring")}</option>
                                                <option value="Multiple">{t("Multiple Voucher")}</option>
                                            </select>
                                        </div>

                                        {
                                            washerSetting.recurrence_type === "Recurring" && (
                                                <div className="form-group">
                                                    <label htmlFor="recurring_period">{t("Period for giving next voucher (days)")}:</label>
                                                    <input
                                                        type="number"
                                                        id="recurring_period"
                                                        name="recurring_period"
                                                        value={washerSetting.recurring_period}
                                                        onChange={e => handleChange("washerSetting", e.target)}
                                                        min="1"
                                                        step="1"
                                                        required
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                            {/* dryer */}
                            <div>
                                <h3>{t("Dryer")}</h3>
                                {/* dryer voucher preview */}
                                <div className="voucher mb-5">
                                    <div className="voucher-ball left-ball"></div>
                                    <div className="voucher-head p-0 m-0" style={{ backgroundColor: selectedColor.headColor }}>
                                        <h4 style={{ width: "140px", height: "140px", padding: "18px 0 0 0" }}>{t("DISCOUNT")}</h4>
                                    </div>

                                    <div className="voucher-content" style={{ background: selectedColor.bodyColor }}>
                                        <div>
                                            <h1>{dryerSetting.voucher_type === "Flat" ? (`${currency(country)}${dryerSetting.voucher_amount}`) : (`${dryerSetting.voucher_amount}%`)}</h1>
                                        </div>

                                        <div>
                                            <h5>{dryerSetting.voucher_title}</h5>
                                            <h6>{dryerSetting.voucher_description}</h6>
                                        </div>
                                    </div>
                                    <div className="voucher-ball right-ball"></div>
                                </div>
                                {/* dryer form */}
                                <div>
                                    <div>
                                        <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_eligible" name="voucher_eligible" checked={dryerSetting.voucher_eligible} onChange={e => handleCheckbox("dryerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the system will give voucher to user who completed dryer stamp collection")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Eligibility")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_expiry" name="voucher_expiry" checked={dryerSetting.voucher_expiry} onChange={e => handleCheckbox("dryerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher will have expired date")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Expiry")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>

                                        <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_washer_use" name="voucher_washer_use" checked={dryerSetting.voucher_washer_use} onChange={e => handleCheckbox("dryerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to washer machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Washer Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_dryer_use" name="voucher_dryer_use" checked={dryerSetting.voucher_dryer_use} onChange={e => handleCheckbox("dryerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to dryer machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Dryer Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_package_use" name="voucher_package_use" checked={dryerSetting.voucher_package_use} onChange={e => handleCheckbox("dryerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to Drop n Go transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Package Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>

                                         <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_vending_use" name="voucher_vending_use" checked={dryerSetting.voucher_vending_use} onChange={e => handleCheckbox("dryerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to vending machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Vending Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_detergent_use" name="voucher_detergent_use" checked={dryerSetting.voucher_detergent_use} onChange={e => handleCheckbox("dryerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to detergent vending machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Detergent Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_carwash_use" name="voucher_carwash_use" checked={dryerSetting.voucher_carwash_use} onChange={e => handleCheckbox("dryerSetting", e.target)} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to car wash transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Car Wash Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        {
                                            dryerSetting.voucher_expiry
                                                ? (
                                                    <div className="form-group">
                                                        <label htmlFor="voucher_duration">{t("Voucher Lifespan")} : <small> ({t("days")})</small></label>
                                                        <input type="number" id="voucher_duration" name="voucher_duration" value={dryerSetting.voucher_duration} onChange={e => handleChange("dryerSetting", e.target)} required min="0" />
                                                    </div>
                                                )
                                                : (
                                                    null
                                                )
                                        }

                                        <div className="form-group">
                                            <label htmlFor="voucher_type">{t("Discount Type")} : </label>
                                            <select className="browser-default form-select" id="voucher_type" name="voucher_type" value={dryerSetting.voucher_type} onChange={e => handleChange("dryerSetting", e.target)} required>
                                                <option value="" disabled>{t("Select a discount type")}</option>
                                                <option value="Flat">{t("Flat")} (- {currency(country)})</option>
                                                <option value="Rate">{t("Rate")} (- %)</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_title">{t("Voucher Title")} : </label>
                                            <input type="text" id="voucher_title" name="voucher_title" placeholder={t("Voucher Title")} value={dryerSetting.voucher_title} onChange={e => handleChange("dryerSetting", e.target)} required />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_description">{t("Voucher Description")} : </label>
                                            <input type="text" id="voucher_description" name="voucher_description" placeholder={t("Voucher Description")} value={dryerSetting.voucher_description} onChange={e => handleChange("dryerSetting", e.target)} required />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_amount">{t("Voucher Amount")} : <small>{dryerSetting.voucher_type === "Flat" ? `(${currency(country)})` : "(%)"}</small></label>
                                            <input type="number" id="voucher_amount" name="voucher_amount" value={dryerSetting.voucher_amount} onChange={e => handleChange("dryerSetting", e.target)} required min="0" />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="recurring_number">{t("Total number of voucher given to user")}:</label>
                                            <input
                                                type="number"
                                                id="recurring_number"
                                                name="recurring_number"
                                                value={dryerSetting.recurring_number}
                                                onChange={e => handleChange("dryerSetting", e.target)}
                                                min="1"
                                                max="100"
                                                step="1"
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="recurrence_type">
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip>{t("Select the voucher recurrence behavior")}</Tooltip>}
                                                >
                                                    <span>{t("Recurrence Type")}</span>
                                                </OverlayTrigger>
                                            </label>
                                            <select
                                                className="browser-default form-select"
                                                id="recurrence_type"
                                                name="recurrence_type"
                                                value={dryerSetting.recurrence_type}
                                                onChange={e => handleChange("dryerSetting", e.target)}
                                            >
                                                <option value="" disabled>{t("Select Recurrence Type")}</option>
                                                <option value="Recurring">{t("Recurring")}</option>
                                                <option value="Multiple">{t("Multiple Voucher")}</option>
                                            </select>
                                        </div>

                                        {
                                            dryerSetting.recurrence_type === "Recurring" && (
                                                <div className="form-group">
                                                    <label htmlFor="recurring_period">{t("Period for giving next voucher (days)")}:</label>
                                                    <input
                                                        type="number"
                                                        id="recurring_period"
                                                        name="recurring_period"
                                                        value={dryerSetting.recurring_period}
                                                        onChange={e => handleChange("dryerSetting", e.target)}
                                                        min="1"
                                                        step="1"
                                                        required
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <input type="submit" value={t("CONFIRM")} className="btn form-control big-button" />
                        </div>
                    </form>
                </div>
            )
        }
    } else {
        // register and birthday only combined setting
        return (
            <div>
                <div>
                    {/* stamp voucher preview */}
                    <div className="voucher mb-5">
                        <div className="voucher-ball left-ball"></div>
                        <div className="voucher-head p-0 m-0" style={{ backgroundColor: selectedColor.headColor }}>
                            <h4 style={{ width: "140px", height: "140px", padding: "18px 0 0 0" }}>{t("DISCOUNT")}</h4>
                        </div>

                        <div className="voucher-content" style={{ background: selectedColor.bodyColor }}>
                            <div>
                                <h1>{combinedSetting.voucher_type === "Flat" ? (`${currency(country)}${combinedSetting.voucher_amount}`) : (`${combinedSetting.voucher_amount}%`)}</h1>
                            </div>

                            <div>
                                <h5>{combinedSetting.voucher_title}</h5>
                                <h6>{combinedSetting.voucher_description}</h6>
                            </div>
                        </div>
                        <div className="voucher-ball right-ball"></div>
                    </div>
                </div>

                <form onSubmit={handleSubmit} id="setting-form">
                    <div className="text-start">
                        {/* checkboxes */}
                        <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                            {
                                selected === "Register" ? (
                                    <div className="form-group">
                                        <label htmlFor="payAndGetRegVoucher">
                                            <input type="checkbox" id="payAndGetRegVoucher" name="payAndGetRegVoucher" checked={payAndGetRegVoucher} onChange={e => handlePayAndGetRegVoucher(e)} />
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        {t("If ticked, the user only can get/use the voucher after make a transaction")}
                                                    </Tooltip>
                                                }
                                            >
                                                <span>{t("Pay And Get Voucher")}</span>
                                            </OverlayTrigger>
                                        </label>
                                    </div>
                                ) : selected === "Birthday" ? (
                                    <div className="form-group">
                                        <label htmlFor="payAndGetBirthdayVoucher">
                                            <input type="checkbox" id="payAndGetBirthdayVoucher" name="payAndGetBirthdayVoucher" checked={payAndGetBirthdayVoucher} onChange={e => handlePayAndGetBirthdayVoucher(e)} />
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        {t("If ticked, the system will only give the voucher to user after the user make a transaction")}
                                                    </Tooltip>
                                                }
                                            >
                                                <span>{t("Pay And Get Voucher")}</span>
                                            </OverlayTrigger>
                                        </label>
                                    </div>
                                ) : null
                            }

                            <div className="form-group">
                                <label htmlFor="voucher_eligible">
                                    <input type="checkbox" id="voucher_eligible" name="voucher_eligible" checked={combinedSetting.voucher_eligible} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t(`If ticked, the system will give voucher to user ${selected === "Register" ? "who completed registration process" : selected === "Birthday" ? "on their birthday month" : "who completed stamp collection"}`)}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Eligibility")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>

                            <div className="form-group">
                                <label htmlFor="voucher_expiry">
                                    <input type="checkbox" id="voucher_expiry" name="voucher_expiry" checked={combinedSetting.voucher_expiry} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the voucher will have expired date")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Expiry")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>
                        </div>

                        <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                            <div className="form-group">
                                <label>
                                    <input type="checkbox" id="voucher_washer_use" name="voucher_washer_use" checked={combinedSetting.voucher_washer_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the voucher can apply to washer machine transaction")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Washer Use")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input type="checkbox" id="voucher_dryer_use" name="voucher_dryer_use" checked={combinedSetting.voucher_dryer_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the voucher can apply to dryer machine transaction")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Dryer Use")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input type="checkbox" id="voucher_package_use" name="voucher_package_use" checked={combinedSetting.voucher_package_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the voucher can apply to Drop n Go transaction")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Package Use")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>
                        </div>

                        <div style={{ maxWidth: "400px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                            <div className="form-group">
                                <label>
                                    <input type="checkbox" id="voucher_vending_use" name="voucher_vending_use" checked={combinedSetting.voucher_vending_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the voucher can apply to vending machine transaction")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Vending Use")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input type="checkbox" id="voucher_detergent_use" name="voucher_detergent_use" checked={combinedSetting.voucher_detergent_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the voucher can apply to detergent vending machine transaction")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Detergent Use")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input type="checkbox" id="voucher_carwash_use" name="voucher_carwash_use" checked={combinedSetting.voucher_carwash_use} onChange={e => handleCheckbox("combinedSetting", e.target)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the voucher can apply to car wash transaction")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Car Wash Use")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div>
                        {/* text and select */}

                        {
                            selected === "Register" && payAndGetRegVoucher ? (
                                <div className="form-group">
                                    <label htmlFor="regVoucherAmount">{t("Minimum Payment Amount To Get/Use Register Voucher")} : <small> ({currency(country)})</small></label>
                                    <input type="number" id="regVoucherAmount" name="regVoucherAmount" value={regVoucherAmount} onChange={e => handleRegVoucherAmount(e)} min="0" required />
                                </div>
                            ) : null
                        }

                        {
                            selected === "Register" && payAndGetRegVoucher ? (
                                <div className="form-group">
                                    <label htmlFor="reg_voucher_method">{t("Voucher Method")} : </label>
                                    <select className="browser-default form-select" id="reg_voucher_method" name="reg_voucher_method" value={reg_voucher_method} onChange={e => handleRegVoucherMethod(e)} required>
                                        <option value="" disabled>{t("Select a voucher method")}</option>
                                        <option value="Register">{t("The user directly get the voucher after register but only can use it after make transaction")}</option>
                                        <option value="Payment">{t("The user only can get voucher after make a transaction")}</option>
                                    </select>
                                </div>
                            ) : null
                        }

                        {
                            selected === "Birthday" && payAndGetBirthdayVoucher ? (
                                <div className="form-group">
                                    <label htmlFor="birthdayVoucherAmount">{t("Minimum Payment Amount To Get Birthday Voucher")} : <small> ({currency(country)})</small></label>
                                    <input type="number" id="birthdayVoucherAmount" name="birthdayVoucherAmount" value={birthdayVoucherAmount} onChange={e => handleBirthdayVoucherAmount(e)} min="0" required />
                                </div>
                            ) : null
                        }

                        {
                            combinedSetting.voucher_expiry
                                ? (
                                    <div className="form-group">
                                        <label htmlFor="voucher_duration">{t("Voucher Lifespan")} : <small> ({t("days")})</small></label>
                                        <input type="number" id="voucher_duration" name="voucher_duration" value={combinedSetting.voucher_duration} onChange={e => handleChange("combinedSetting", e.target)} required min="0" />
                                    </div>
                                )
                                : (
                                    null
                                )
                        }

                        <div className="form-group">
                            <label htmlFor="voucher_type">{t("Discount Type")} : </label>
                            <select className="browser-default form-select" id="voucher_type" name="voucher_type" value={combinedSetting.voucher_type} onChange={e => handleChange("combinedSetting", e.target)} required>
                                <option value="" disabled>{t("Select a discount type")}</option>
                                <option value="Flat">{t("Flat")} (- {currency(country)})</option>
                                <option value="Rate">{t("Rate")} (- %)</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="voucher_title">{t("Voucher Title")} : </label>
                            <input type="text" id="voucher_title" name="voucher_title" placeholder={t("Voucher Title")} value={combinedSetting.voucher_title} onChange={e => handleChange("combinedSetting", e.target)} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="voucher_description">{t("Voucher Description")} : </label>
                            <input type="text" id="voucher_description" name="voucher_description" placeholder={t("Voucher Description")} value={combinedSetting.voucher_description} onChange={e => handleChange("combinedSetting", e.target)} required />
                        </div>

                        <div className="form-group">
                            <label htmlFor="voucher_amount">{t("Voucher Amount")} : <small>{combinedSetting.voucher_type === "Flat" ? `(${currency(country)})` : "(%)"}</small></label>
                            <input type="number" id="voucher_amount" name="voucher_amount" value={combinedSetting.voucher_amount} onChange={e => handleChange("combinedSetting", e.target)} required min="0" />
                        </div>

                        <div className="form-group">
                            <label htmlFor="recurring_number">{t("Total number of voucher given to user")}:</label>
                            <input
                                type="number"
                                id="recurring_number"
                                name="recurring_number"
                                value={combinedSetting.recurring_number}
                                onChange={e => handleChange("combinedSetting", e.target)}
                                min="1"
                                max="100"
                                step="1"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="recurrence_type">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>{t("Select the voucher recurrence behavior")}</Tooltip>}
                                >
                                    <span>{t("Recurrence Type")}</span>
                                </OverlayTrigger>
                            </label>
                            <select
                                className="browser-default form-select"
                                id="recurrence_type"
                                name="recurrence_type"
                                value={combinedSetting.recurrence_type}
                                onChange={e => handleChange("combinedSetting", e.target)}
                            >
                                <option value="" disabled>{t("Select Recurrence Type")}</option>
                                <option value="Recurring">{t("Recurring")}</option>
                                <option value="Multiple">{t("Multiple Voucher")}</option>
                            </select>
                        </div>

                        {
                            combinedSetting.recurrence_type === "Recurring" ? (
                                <div className="form-group">
                                    <label htmlFor="recurring_period">{t("Period for giving next voucher (days)")}:</label>
                                    <input
                                        type="number"
                                        id="recurring_period"
                                        name="recurring_period"
                                        value={combinedSetting.recurring_period}
                                        onChange={e => handleChange("combinedSetting", e.target)}
                                        min="1"
                                        step="1"
                                        required
                                    />
                                </div>
                            ) : null
                        }
                    </div>

                    <div className="my-4">
                        <input type="submit" value={t("CONFIRM")} className="btn big-button form-control" />
                    </div>
                </form>
            </div>
        );
    }
};

export default SettingForm;